/*
  src/redux/auth/actions.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import Cookies from 'js-cookie';
import callAuth from '../callAuth';

import {
  TOKEN_LOADED_FROM_COOKIE,
  TOKEN_FAILED_TO_LOAD_FROM_COOKIE,
  TOKEN_REQUESTED,
  TOKEN_LOADED,
  TOKEN_INVALIDATED,
  TOKEN_FAILED_TO_LOAD
} from './constants';

export function loadAuthTokenFromCookie(){
  const token = Cookies.get('authToken'),
    refresh = Cookies.get('refreshToken'),
    email = Cookies.get('authPrincipal');

  if(token && email && refresh){
    return {
      type:TOKEN_LOADED_FROM_COOKIE,
      payload:{
        token,
        email
      }
    };
  } else {
    return {
      type:TOKEN_FAILED_TO_LOAD_FROM_COOKIE
    }
  }
}

export function invalidateAuthToken(){
  Cookies.remove('authToken');
  Cookies.remove('refreshToken');
  Cookies.remove('authPrincipal');

  return {
    type:TOKEN_INVALIDATED
  };
}

export function requestAuthTokenWithCredentials(email,password){
  Cookies.set('authPrincipal',email);

  return callAuth({
    method:'POST',
    path:'/oauth/token',
    body:{
      password:password,
      username:email,
      grant_type:'password',
      scope:'APIv3.read APIv3.write'
    },
    begin:{
      type:TOKEN_REQUESTED,
      payload:() => email
    },
    success:{
      type:TOKEN_LOADED,
      payload:(res) => res.access_token,
      result:(res) => {
        Cookies.set('authToken',res.access_token);
        Cookies.set('refreshToken',res.refresh_token);
      }
    },
    failure:{
      type:TOKEN_FAILED_TO_LOAD
    }
  });
}



// WEBPACK FOOTER //
// ./src/shared/redux/auth/actions.js